import * as React from 'react';
import { ActorApiNumberDisplay } from '../../../../../../components/display/number/component';
import { useAccountPositionGesEstimDPcPvGlo } from '../../hooks';

export const AccountsPositionsGesEstimDPcPvGlo = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionGesEstimDPcPvGlo();
  return (
    <ActorApiNumberDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={{
        style: 'percent',
      }}
    />
  );
};
